export class ActionStatus {
    public done = 'fait';
    public inProgress = 'lance';
    public cancelled = 'annuler';
    public all = 'tous';
}
